import { useTranslation } from 'react-i18next'

import { type Quote } from '../../../modules/quotes'
import { useQuoteContext } from '../QuoteComponent.context'
import { mergeClassName } from '../../../utils/mergeClassName'

type FooterProps = {
  quote: Quote
  className?: string
}

const Footer: React.FC<FooterProps> = ({ quote, className }) => {
  const { t } = useTranslation()
  const { open, cta } = useQuoteContext()
  if (!open) {
    return null
  }

  const minLabourHours = quote.jobs[0].jobResolvedBranch.pricing.minLabourTime ?? 0
  const multiJobs = quote.jobs.length > 1

  if (!minLabourHours && !cta) {
    return null
  }

  const stopPropagation = (event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <div className={mergeClassName(
      'flex flex-col items-center justify-between gap-y-4 border-t py-4 sm:flex-row sm:pb-0',
      className,
    )}
    >
      <div className="text-sm text-gray-500">
        { !!minLabourHours && (
          <span>
            { multiJobs
              ? t('quotes.quote.minLabourTimeMultiJobs', { minLabourHours })
              : t('quotes.quote.minLabourTime', { minLabourHours }) }
          </span>
        ) }
      </div>

      <div onClick={stopPropagation}>
        { cta }
      </div>
    </div>
  )
}

export default Footer
